export default "__VITE_ASSET__Cd1P6vAS__"